import { createStore, combineReducers, applyMiddleware, compose } from "redux"
import moment from "moment"
import { createBrowserHistory } from "history"
import { routerReducer, routerMiddleware, push } from "react-router-redux"
import gaMiddleware from "./gaMiddleware"
import qs from "query-string"
import dateRangeMiddleware from "./dateRangeMiddleware"
import { GRAPHQL_DATE_FORMAT } from "../helpers/sharedConstants"

const initialState = {
  startDate: moment()
    .subtract(30, "days")
    .startOf("day")
    .toJSON(),
  endDate: moment()
    .subtract(1, "days")
    .startOf("day")
    .toJSON(),
}

const bsrInitialState = {
  bsrCompliance: false,
}

const bsrComplianceReducer = (state = bsrInitialState, action) => {
  switch (action.type) {
    case "bsrCompliance/CHANGE_COMPLIANCE":
      return {
        bsrCompliance: !state.bsrCompliance,
      }
    default:
      return {
        bsrCompliance: state.bsrCompliance,
      }
  }
}

const dateRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE": {
      let params, startDate, endDate
      if (
        (params = qs.parse(action.payload.search)) &&
        params.startDate &&
        params.endDate &&
        (startDate = moment(params.startDate, GRAPHQL_DATE_FORMAT)).isValid() &&
        (endDate = moment(params.endDate, GRAPHQL_DATE_FORMAT)).isValid()
      ) {
        return {
          ...state,
          startDate: startDate.toJSON(),
          endDate: endDate.toJSON(),
        }
      } else {
        return state
      }
    }
    default:
      return state
  }
}

export const updateDateRange = (startDate, endDate) =>
  push({
    search: qs.stringify({
      startDate: startDate.format(GRAPHQL_DATE_FORMAT),
      endDate: endDate.format(GRAPHQL_DATE_FORMAT),
    }),
  })

export const toggleBsrCompliance = { type: "bsrCompliance/CHANGE_COMPLIANCE" }

const storeWithHistory = () => {
  const history = createBrowserHistory()
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  return {
    store: createStore(
      combineReducers({
        dateRange: dateRangeReducer,
        router: routerReducer,
        bsrCompliance: bsrComplianceReducer,
      }),
      composeEnhancers(
        applyMiddleware(
          routerMiddleware(history),
          dateRangeMiddleware,
          gaMiddleware
        )
      )
    ),
    history: history,
  }
}

export default storeWithHistory
